"use client"

import { Heading3 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Heading3Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Heading3Icon = component(Icon)({ as: Heading3 })
